import { Controller } from "stimulus"
export default class extends Controller {
  static get targets() {
    return ["calculatedPrice", "originalCalculatedPrice"];
  }

  initialize(){
    this.basePrice = parseFloat(this.element.getAttribute("data-base-price"))
     this.formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      });
    this.quantity = 1;
    this.recalculatePrice(); 
  }

  recalculate_option(e){
    this.recalculatePrice();
  }

  recalculate_quantity(e){
    this.quantity = parseInt(e.target.value);
    this.recalculatePrice();
  }


  recalculatePrice(){
    let selects = document.getElementsByClassName("bulk-pricing__option");
    let add_to_price = 0.0;
    if(selects.length > 0){
      for(let i = 0;i < selects.length;i++){
        let s = selects[i];
        let s_prices = JSON.parse(s.getAttribute("data-bulk-price-add"));

        let f = s_prices[s.value];
        if(f != null){
          add_to_price += parseFloat(f);
        }
      }
    }
    let bulk = document.getElementById("bulk-pricing__table")

    if(bulk != null){

      let unit_prices = document.getElementsByClassName("bulk-pricing__unit-price");
      for(let u=0;u< unit_prices.length;u++){
        let unit_element = unit_prices[u];
        let uprice = unit_element.getAttribute("data-bulk-base-price");
        unit_element.innerText = this.formatter.format(parseFloat(uprice) + add_to_price).replace("$","");
      }

      let tiers = JSON.parse(bulk.getAttribute("data-bulk-price-tiers"));
      tiers = tiers.sort(function (a, b) {
        let aq = parseFloat(a["qty"]);
        let bq = parseFloat(b["qty"]);
          if(aq > bq){
            return -1;
          }
          else if (bq > aq){
            return 1;
          }
          return 0;
      });
      for(let t=0;t < tiers.length;t++){
        if(parseFloat(tiers[t]["qty"]) <= this.quantity  ){
          this.writePrice(parseFloat(tiers[t]["unit_price"]) + add_to_price, this.calculatedPriceTarget, false);
          break;
        }
      }
    }
    else {
      this.writePrice(this.basePrice + add_to_price, this.calculatedPriceTarget, false);
    }

    if (this.hasOriginalCalculatedPriceTarget){
       let originalPrice = parseFloat(this.originalCalculatedPriceTarget.dataset.originalPrice); 
       this.writePrice(originalPrice + add_to_price, this.originalCalculatedPriceTarget); 
    }
  }

  writePrice(price, target, showCurrency=true){
    let replacement =  this.formatter.format(Math.round(price * 100) / 100);
    if (!showCurrency){
      replacement = replacement.replace("$", "") 
    }
    target.innerText = replacement; 
  }

}



// WEBPACK FOOTER //
// ./app/javascript/store_front/controllers/product_details_price_controller.js